export default "__VITE_ASSET__CuYwLt0E__"